import { Button } from '@/components/Button';
import { Link } from '@/components/Link';

const checkoutUrl = 'checkout';

export type BuyGiftcardProps = {
  store: AdaptedStore<true>;
  displayNetworks: AdaptedStore<true>['networks'];
  content: StoreProfilePageContent;
};

export function BuyGiftcard({
  store,
  displayNetworks,
  content,
}: BuyGiftcardProps) {
  const {
    buyGiftcardTitle,
    buyGiftcardDescription,
    buyStoreGiftcardDescription,
    buyNetworkGiftcardDescription,
    giftcard,
  } = content.profile;

  const hasNetworks = displayNetworks.length > 0;

  return (
    <div className="flex max-w-[90vw] flex-col items-start gap-y-5 rounded-lg bg-white px-8 py-6 shadow-2xl">
      <div className="flex w-full flex-col items-start gap-y-2">
        <h2 className="text-xl">{buyGiftcardTitle}</h2>

        <p className="text-sm">{buyGiftcardDescription}</p>
      </div>

      <hr className="w-full border-gray-200" />

      {store.settings.marketplacesEnabled && (
        <div className="flex w-full flex-col gap-2">
          <p className="mb-2 text-sm">{buyStoreGiftcardDescription}</p>

          <Link
            href={`/${checkoutUrl}/${store.zmyleUri}`}
            className="w-full"
            isExternal
          >
            <Button className="w-full" variant="store">
              {`${store.name} ${giftcard}`}
            </Button>
          </Link>
        </div>
      )}

      <div className="flex w-full flex-col gap-2">
        {hasNetworks && (
          <p className="mb-2 text-sm">{buyNetworkGiftcardDescription}</p>
        )}

        {displayNetworks.map(network => (
          <Link
            key={network.id}
            href={`/${checkoutUrl}/${network.slug}`}
            className="w-full"
            isExternal
          >
            <Button className="w-full" variant="network">
              {network.name}
            </Button>
          </Link>
        ))}
      </div>
    </div>
  );
}
